// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://localhost:44335/',

  authentication: {
    issuer: 'https://core-int.bdx-cloud.com/ids',
    clientId: 'HSPA-dev',
    scope: 'openid profile offline_access email idmauthz.access idmauthz.readuserpermissions idmauthz.managetenants idmauthz.manageorganizationalresources idmauthz.config',
    idmAuthPortalUrl: "https://coreui-int.bdx-cloud.com/",
  },
  inactivityTimeout: {
    sessionIdleTimeoutInMinutes: 10, // In minutes
    idleWarningCounterInMinutes: 3 // In minutes
  },
  tokenBase64Key:"#{tokenBase64Key}#"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
